import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TranslateIcon from "@mui/icons-material/Translate";
import { useMemo, useState } from "react";
import { applyPreferredLanguage, getPreferredLanguage } from "utils/LanguageUtils";

function LanguageDropdown({ compact = false }) {
  const [language, setLanguage] = useState(getPreferredLanguage());

  const size = useMemo(() => (compact ? "small" : "small"), [compact]);

  const onLanguageChange = (event) => {
    const lang = event.target.value;
    setLanguage(lang);
    applyPreferredLanguage(lang);
  };

  return (
    <FormControl
      size={size}
      sx={{ minWidth: compact ? 120 : 132 }}
    >
      <InputLabel id="language-switcher-label">Language</InputLabel>
      <Select
        labelId="language-switcher-label"
        id="language-switcher"
        value={language}
        label="Language"
        onChange={onLanguageChange}
        startAdornment={<TranslateIcon sx={{ mr: 1, color: "text.light" }} fontSize="small" />}
      >
        <MenuItem value="en">English (EN)</MenuItem>
        <MenuItem value="es">Espanol (ES)</MenuItem>
      </Select>
    </FormControl>
  );
}

export default LanguageDropdown;
